import React from 'react'
import { Add as AddIcon, Delete as DeleteIcon } from 'icons'
import { useBrands } from 'contexts/Brand'
import { useBrandImporter } from "hooks/useBrandImporter"

import Brands from './brands'

export function SetUpBrandsContainer() {
  const { onCreate, onDelete } = useBrandImporter()
  const {
    imported: secondaryCollection,
    notImported: primaryCollection
  } = useBrands()

  const primaryActions = [
    {
      Icon: AddIcon,
      title: 'Import',
      color: 'success',
      onClick: item => onCreate(item)
    }
  ]
  const secondaryActions = [
    {
      Icon: DeleteIcon,
      title: 'Remove',
      color: 'error',
      onClick: item => onDelete(item)
    }
  ]
  return (
    <Brands
      primaryActions={primaryActions}
      secondaryActions={secondaryActions}
      primaryCollection={primaryCollection}
      secondaryCollection={secondaryCollection}
    />
  )
}

export default SetUpBrandsContainer
